import { EventBus } from 'pdfjs-dist/legacy/web/pdf_viewer.mjs';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// interface EventBus {
//   on(eventName: string, listener: Function): void;
//   off(eventName: string, listener: Function): void;
//   _listeners: any;
//   dispatch(eventName: string, data: Object): void;
//   _on(eventName: any, listener: any, options?: null): void;
//   _off(eventName: any, listener: any, options?: null): void;
// }

export function createEventBus(destroy$: Subject<void>) {
  const globalEventBus: EventBus = new EventBus();
  attachDOMEventsToEventBus(globalEventBus, destroy$);
  return globalEventBus;
}

function attachDOMEventsToEventBus(eventBus: EventBus, destroy$: Subject<void>): void {
  fromEvent(eventBus, 'documentload')
    .pipe(takeUntil(destroy$))
    .subscribe(() => {
      const event = document.createEvent('CustomEvent');
      event.initCustomEvent('documentload', true, true, {});
      window.dispatchEvent(event);
    });

  fromEvent(eventBus, 'pagerendered')
    .pipe(takeUntil(destroy$))
    .subscribe(({ pageNumber, cssTransform, source }): void => {
      const event = document.createEvent('CustomEvent');
      event.initCustomEvent('pagerendered', true, true, {
        pageNumber,
        cssTransform,
      });
      source.div.dispatchEvent(event);
    });

  // fromEvent(eventBus, 'textlayerrendered')
  //   .pipe(takeUntil(destroy$))
  //   .subscribe(({ pageNumber, source }) => {
  //     const event = document.createEvent('CustomEvent');
  //     event.initCustomEvent('textlayerrendered', true, true, { pageNumber });
  //     source.textLayerDiv.dispatchEvent(event);
  //   });

  fromEvent(eventBus, 'pagechanging')
    .pipe(takeUntil(destroy$))
    .subscribe(({ pageNumber, source }) => {
      const event = document.createEvent('UIEvents');
      event.initEvent('pagechanging', true, true);
      /* tslint:disable:no-string-literal */
      event['pageNumber'] = pageNumber;
      source.container.dispatchEvent(event);
    });

  fromEvent(eventBus, 'pagesinit')
    .pipe(takeUntil(destroy$))
    .subscribe(({ source }) => {
      const event = document.createEvent('CustomEvent');
      event.initCustomEvent('pagesinit', true, true, null);
      source.container.dispatchEvent(event);
    });

  fromEvent(eventBus, 'scalechange')
    .pipe(takeUntil(destroy$))
    .subscribe(({ scale, presetValue, source }) => {
      const event = document.createEvent('UIEvents');
      event.initEvent('scalechange', true, true);
      /* tslint:disable:no-string-literal */
      event['scale'] = scale;
      /* tslint:disable:no-string-literal */
      event['presetValue'] = presetValue;
      source.container.dispatchEvent(event);
    });
}
